/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ManualEmailTaskCreateBodyDoc } from './manualEmailTaskCreateBodyDoc';
import type { ManualEmailTaskCreatePriority } from './manualEmailTaskCreatePriority';
import type { ManualEmailTaskCreateSubjectDoc } from './manualEmailTaskCreateSubjectDoc';
import type { ManualEmailTaskCreateTaskNoteDoc } from './manualEmailTaskCreateTaskNoteDoc';
import type { ManualEmailTaskCreateThreadMode } from './manualEmailTaskCreateThreadMode';

export interface ManualEmailTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: ManualEmailTaskCreatePriority;
  title?: string | null;
  type: 'manual_email';
  mailbox_id?: string | null;
  to_email?: string | null;
  /** @maxLength 998 */
  subject?: string;
  subject_doc?: ManualEmailTaskCreateSubjectDoc;
  body_doc: ManualEmailTaskCreateBodyDoc;
  thread_mode?: ManualEmailTaskCreateThreadMode;
  /** @maxItems 20 */
  cc?: string[];
  /** @maxItems 20 */
  bcc?: string[];
  include_sender_signature?: boolean;
  include_unsubscribe_link?: boolean;
  task_note_doc?: ManualEmailTaskCreateTaskNoteDoc;
}
